<template>
  <div class="page page-adspreset">
    <CreateAdsModal
      v-if="state.isCreateModalShowing"
      :statusMessage="createAdsMessage"
      :onClose="onCloseCreateModal"
      :onSubmit="onSubmitCreateAds" />
    <EditAdsModal
      v-if="state.isEditModalShowing"
      :statusMessage="editAdsMessage"
      :selectedAds="selectedAds"
      :onClose="onCloseEditModal"
      :onSubmit="onSubmitEditAds" />
    <div v-if="isLoading">
      <LoadingState />
    </div>
    <div class="container" v-if="!isLoading">
      <div class="section section-adspreset-browser">
        <div class="list-group">
          <div class="list-header">
            <div class="total">Sort by Newest</div>
            <div class="actions">
              <button type="button" class="btn btn-success" @click="onShowCreateModal">
                Create Ads
              </button>
            </div>
          </div>
          <div class="list-item" v-for="(item, index) in adsPreset" :key="index">
            <div class="list-item-content">
              <div class="title">{{item.name}}</div>
              <div class="sub-title">
                created at <span v-if="item.createdAt">{{ getDateTime(item.createdAt) }}</span>
              </div>
            </div>
            <div class="list-item-actions">
              <a class="action-items" :href="item.adsTagUrl" target="_blank" title="open adstag on new tab">
                <i class="fas fa-link"></i>
              </a>
              <button class="btn action-items btn-edit"
                title="change ads name"
                type="button" @click.stop="onShowEditModal(item)">
                <span class="d-none d-sm-block">Edit</span>
                <span class="d-block d-sm-none"><i class="fas fa-pen"></i></span>
              </button>
            </div>
          </div>
          <div class="list-item" v-if="adsPreset.length === 0">
            <div class="list-item-content list-item-primary text-center">
              <div class="title">No Ads</div>
              <div class="sub-title">Please create one for publish Ads</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDateTime, parseErrors } from '@/modules/utilities';
import { loadAdsPreset, createAdsPreset, updateAdsPreset } from '@/modules/api/AdsPreset';
import LoadingState from '@/components/elements/LoadingState';
import CreateAdsModal from '@/components/parts/ads-preset/CreateAdsModal';
import EditAdsModal from '@/components/parts/ads-preset/EditAdsModal';

export default {
  components: {
    LoadingState,
    CreateAdsModal,
    EditAdsModal,
  },
  data() {
    return {
      isLoading: true,
      state: {
        isCreateModalShowing: false,
        isEditModalShowing: false,
      },
      createAdsMessage: {
        error: null,
      },
      editAdsMessage: {
        error: null,
      },
      adsPreset: [],
      selectedAds: null,
    };
  },
  created() {
    this.load();
  },
  methods: {
    getDateTime,
    parseErrors,
    async load() {
      try {
        const response = await loadAdsPreset();
        this.adsPreset = response.data;
        this.isLoading = false;
      } catch (e) {
        console.log(e);
      }
    },
    onCloseCreateModal() {
      this.state.isCreateModalShowing = false;
    },
    onShowCreateModal() {
      this.state.isCreateModalShowing = true;
    },
    async onSubmitCreateAds(item) {
      try {
        await createAdsPreset(item);
        this.onCloseCreateModal();
        // reload item
        this.load();
      } catch (error) {
        const errorResponse = error.response ? error.response.data : null;
        this.createAdsMessage = parseErrors(errorResponse);
      }
    },
    clearSelectedAds() {
      this.selectedAds = null;
    },
    onCloseEditModal() {
      this.state.isEditModalShowing = false;
      this.clearSelectedAds();
    },
    onShowEditModal(ads) {
      this.selectedAds = ads;
      this.state.isEditModalShowing = true;
    },
    async onSubmitEditAds(item) {
      try {
        await updateAdsPreset(this.selectedAds._id, item);
        this.onCloseEditModal();
        this.clearSelectedAds();
        // reload item
        this.load();
      } catch (error) {
        const errorResponse = error.response ? error.response.data : null;
        this.editAdsMessage = parseErrors(errorResponse);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/themes/helper.scss';
@import '@/assets/scss/themes/variables.scss';

</style>



// WEBPACK FOOTER //
// src/components/pages/ads-preset/ManageAdsPresetBrowser.vue